import {NatGetRoomNumberList} from './NatGetRoomNumberList'
import Http from '../../../../network/Http'
import {Nullable} from '../../../../app/TypeHelpers'
import {formatDateLocal} from '../../../../formatters/formatMoment'
import moment from 'moment'
import {ContentType} from '../../../../network/Constants'
import {NatGetAdminRoomNumberList} from './NatGetAdminRoomNumberList'

export default class NatRoomNumberRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    // 部屋番号一覧取得
    async getRoomNumberList(
        ridgeCd: string,
        roomNumber: string,
        validPeriodCriteriaDate: Nullable<moment.Moment>,
        cardKeyNumberIsNotNullFlg: boolean,
    ): Promise<NatGetRoomNumberList> {
        const queries: string[] = []
        if (ridgeCd !== '') {
            queries.push(`ridgeCd=${encodeURIComponent(ridgeCd)}`)
        }
        if (roomNumber !== '') {
            queries.push(`roomNumber=${encodeURIComponent(roomNumber)}`)
        }
        if (validPeriodCriteriaDate != null) {
            const formatValidPeriodCriteriaDate = formatDateLocal(validPeriodCriteriaDate)
            queries.push(`validPeriodCriteriaDate=${encodeURIComponent(formatValidPeriodCriteriaDate)}`)
        }
        if (cardKeyNumberIsNotNullFlg) {
            queries.push(`cardKeyNumberIsNotNullFlag=1`)
        }
        const query = queries.join('&')

        return await this.http.get(`/api/resident/roomNumber?${query}`)
    }

    // 部屋番号一覧取得(管理)
    async getAdminRoomNumberList(
        condominiumCd?: string,
        ridgeCd?: string,
        roomNumber?: string
    ): Promise<NatGetAdminRoomNumberList> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/roomNumberList`,
            {
                condominiumCd: condominiumCd || null,
                ridgeCd: ridgeCd || null,
                roomNumber: roomNumber || null,
            },
            ContentType.JSON
        )
    }

}
